import React from "react";

import { useTabsContext } from "./Tabs";

//

export interface CurrentTabProps {}

export const CurrentTab: React.FC<CurrentTabProps> = () => {
  const tab = useTabsContext((s) => s.tab);
  const tabProps = useTabsContext((s) => s.tabProps);
  return tab.render(...tabProps);
};
